import React from 'react';
import aboutimg from '../../images/staff.PNG';
import {useTranslation } from "react-i18next";   

function AboutUs() {
    const { t, i18n } = useTranslation();

    return (
    <section id="about" className="about">
        <div className="container" >
            <div className="row">
                <div className="col-lg-6 order-1 order-lg-2">
                    <div className="about-img">
                        <img src={aboutimg} alt="Old Tbilisi talented team"/>                     
                    </div>              
                </div>
                <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content">
                    <div className="section-title">
                        <h2>{t("about-us")}</h2>
                        <p>
                        {t("about")}                      
                        </p>
                    </div>                    
                    <p className="font-italic">
                    {t("about-us-p-1")}                    
                    </p>
                    <p className="font-italic">
                    {t("about-us-p-2")}                    
                    </p>
                    <p className="font-italic">
                    {t("about-us-li-1")}                
                    </p>
                    <p className="font-italic">
                    {t("about-us-li-2")}                
                    </p>
                    <p className="font-italic">
                    {t("about-us-li-3")}                
                    </p>                  
                    <ul>
                        <li><i className="fas fa-check"></i>    <a href="https://www.takeaway.com/be-en/menu/old-tbilisi-georgisch-restaurant" target="_blank" rel="noreferrer">{t("about-us-p-3")}</a>  </li>
                 
                    </ul>                                               
                </div>
            </div>
        </div>
    </section>
    )
}

export default AboutUs;
